import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Loader } from '@/components/Loader/Loader'
import { AppRoutes } from '@/constants/appRoutes'
import { useSSO } from '@/hooks/Auth'
import { useAppDispatch } from '@/hooks/redux'

export const AuthSuccess = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()

  const { successSSO } = useSSO()

  useEffect(() => {
    // These are needed for the Login & SignUp flow, and can't be null
    const token = searchParams.get('token')
    const status = searchParams.get('status')
    const email = searchParams.get('email')

    // These are needed for the SignUp flow, and can be null
    const id = searchParams.get('id')

    if (!token || !status || !email) {
      navigate(AppRoutes.login)
      return
    }

    successSSO(token, status, email, id)
  }, [searchParams, navigate, dispatch])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4">
        <Loader />
        <p className="text-lg text-textAccent">
          {t('auth.authSuccess.completingAuthentication')}
        </p>
      </div>
    </div>
  )
}

export default AuthSuccess
